/* eslint-disable import/no-mutable-exports */

interface Content {
  [key: string]: any;
}

export let content: Content = {};

export const initContent = () => {
  content = JSON.parse((window as any)?.clientData?.cmsContent);
};
